// extracted by mini-css-extract-plugin
export default {"content":"Body_content__JC3qb"};